/* @flow */
import React, { Component } from 'react';
import GraphiQL from 'graphiql';
import 'graphiql/graphiql.css';

import { connect } from 'react-redux';

import { serverUrl } from '../../service';
import './graphiql.css';

const defaultQuery = `
{
  viewer {
    sites {
      edges {
        node {
          id
        }
      }
    }
  }
}
`;

type Props = {
  token: string,
};

type State = {
  query: ?string,
  response: ?string,
  variables: ?string,
  operationName: ?string,
};

const formatJson = data => {
  if (data) {
    return JSON.stringify(JSON.parse(data), null, 2);
  }

  return '';
};

class GraphiQLPage extends Component<Props, State> {
  state = {
    query: null,
    response: null,
    variables: null,
    operationName: null,
  };

  graphQLFetcher = graphQLParams => {
    const { token } = this.props;

    return fetch(`${serverUrl}/graphql`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Authentication-Token': `${token}`,
      },
      body: JSON.stringify(graphQLParams),
    }).then(response => response.json());
  };

  handleAuditClicked = ({ query = '', variables, response }) => {
    this.setState({
      query,
      variables: formatJson(variables),
      response: formatJson(response),
    });
  };

  render() {
    const { query, variables, response, operationName } = this.state;

    return (
      <GraphiQL
        fetcher={this.graphQLFetcher}
        defaultQuery={defaultQuery}
        query={query}
        response={response}
        variables={variables}
        onEditQuery={value => this.setState({ query: value })}
        onEditOperationName={value => this.setState({ operationName: value })}
        onEditVariables={value => this.setState({ variables: value })}
        operationName={operationName}
      />
    );
  }
}

// $FlowFixMe
export default connect(state => ({ token: state.auth.token }))(GraphiQLPage);



// WEBPACK FOOTER //
// ./src/components/testing/GraphiQL.js